export default __webpack_public_path__ + "static/media/google-play-badge.3f918a83.png";